async function handleAuthor_id(Email,connection,tokenObject){

    const result = await connection.post("/User",
        {
            Email:Email
        },
        {
        headers:{
            'user-access-token':tokenObject.token
        },
    });

    const User_id = result.data._id;

    return User_id;
}

export default handleAuthor_id;